import Dashboard from "../views/Dashboard";
import Revenue from "../views/Revenue";
import Profile from "../views/Profile";
import Users from "../views/User/Users";
import ViewUser from "../views/User/ViewUser";
import VehicleSearch from "../views/VehicleSearch/VehicleSearch";
import ViewVehicleSearch from "../views/VehicleSearch/ViewVehicleSearch";
import Replacement from "../views/Replacement/Replacement";
import ViewReplacement from "../views/Replacement/ViewReplacement";
import ShippingOrder from "../views/ShippingOrder/ShippingOrder";
import ViewShippingOrder from "../views/ShippingOrder/ViewShippingOrder";
import QRCode from "../views/QRCode/QRCode";
import ViewQrCode from "../views/QRCode/ViewQrCode";
import SupportQuery from "../views/SupportQuery/SupportQuery";
import ViewSupportQuery from "../views/SupportQuery/ViewSupportQuery";
import Executive from "../views/Executive/Executive";
import ViewExecutive from "../views/Executive/ExecutiveForm/ViewExecutive";
import EditExecutive from "../views/Executive/ExecutiveForm/EditExecutive";
import AddExecutive from "../views/Executive/ExecutiveForm/AddExecutive";
import Banner from "../views/Banner/Banner";
// Vehicle Brands / Models hidden from the admin panel for now. To bring them back,
// uncomment these imports, the routes below, and the two menu items in App.js.
// import VehicleBrand from "../views/VehicleBrand/VehicleBrand";
// import AddVehicleBrand from "../views/VehicleBrand/VehicleBrandForm/AddVehicleBrand";
// import ViewVehicleBrand from "../views/VehicleBrand/VehicleBrandForm/ViewVehicleBrand";
// import EditVehicleBrand from "../views/VehicleBrand/VehicleBrandForm/EditVehicleBrand";
// import ViewVehicleModel from "../views/VehicleModel/VehicleModelForm/ViewVehicleModel";
// import AddVehicleModel from "../views/VehicleModel/VehicleModelForm/AddVehicleModel";
// import EditVehicleModel from "../views/VehicleModel/VehicleModelForm/EditVehicleModel";
// import VehicleModel from "../views/VehicleModel/VehicleModel";
import StaticPage from "../views/StaticPage/StaticPage";
import AddStaticPage from "../views/StaticPage/StaticPageForm/AddStaticPage";
import ViewStaticPage from "../views/StaticPage/StaticPageForm/ViewStaticPage";
import EditStaticPage from "../views/StaticPage/StaticPageForm/EditStaticPage";
import CallLogs from "../views/CallLogs/CallLogs";
import ViewCallLogs from "../views/CallLogs/CallLogsForm/ViewCallLogs";
import ExpiredMembershipUsers from "../views/ExpiredMembershipUsers/ExpiredMembershipUsers";
import ViewEarnings from "../views/Executive/ExecutiveForm/ViewEarnings";
import Invoice from "../views/invoice/Invoice";
import ViewInvoice from "../views/invoice/ViewInvoice";
import PaymentHistory from "../views/Payment/Payment";
import DemoVideo from "../views/DemoVideo/DemoVideo";
import UserSubscriptions from "../views/UserSubscriptions/UserSubscriptions";
import { elements } from "chart.js/auto";
import SubAdmins from "../views/SubAdmin/SubAdmins";
import SubAdminForm from "../views/SubAdmin/SubAdminForm";
import ResetSubAdminPassword from "../views/SubAdmin/ResetSubAdminPassword";
import Forbidden from "../pages/Forbidden";

export const PrivateRoutes = [
    { path: "/dashboard", name: "Dashboard", element: <Dashboard />, permission: "dashboard.view" },
    { path: "/revenue", name: "Revenue", element: <Revenue />, permission: "revenue.view" },
    { path: "/user", name: "User", element: <Users />, permission: "users.view" },
    { path: "/user/view/:id", name: "View", element: <ViewUser />, permission: "users.view" },
    { path: "/vehicle-search", name: "Vehicle Search", element: <VehicleSearch />, permission: "vehicle_search.view" },
    { path: "/vehicle-search/view/:id", name: "View", element: <ViewVehicleSearch />, permission: "vehicle_search.view" },
    { path: "/profile", name: "Profile", element: <Profile /> },
    { path: "/replacement", name: "Replacement", element: <Replacement />, permission: "replacement.view" },
    { path: "/replacement/view/:id", name: "View", element: <ViewReplacement />, permission: "replacement.view" },
    { path: "/shipping-order", name: "Shipping Order", element: <ShippingOrder />, permission: "shipping_order.view" },
    { path: "/shipping-order/:id", name: "View", element: <ViewShippingOrder />, permission: "shipping_order.view" },
    { path: "/qr-code", name: "QR-Code", element: <QRCode />, permission: "qr_code.view" },
    { path: "/qr-code/view/:id", name: "View", element: <ViewQrCode />, permission: "qr_code.view" },
    { path: "/support-query", name: "List", element: <SupportQuery />, permission: "support_query.view" },
    { path: "/support-query/:id", name: "View", element: <ViewSupportQuery />, permission: "support_query.view" },
    { path: "/executive", name: "List", element: <Executive />, permission: "executive.view" },
    { path: "/executive-payroll", name: "Executive Payroll", element: <ViewEarnings />, permission: "executive.payroll" },
    { path: "/executive/view/:id", name: "View", element: <ViewExecutive />, permission: "executive.view" },
    { path: "/executive/view-earnings/:id", name: "View Earnings", element: <ViewEarnings />, permission: "executive.payroll" },
    { path: "/executive/add", name: "Add Executive", element: <AddExecutive />, permission: "executive.create" },
    { path: "/executive/edit/:id", name: "Edit Executive", element: <EditExecutive />, permission: "executive.update" },
    { path: "/banner", name: "Banner", element: <Banner />, permission: "banners.view" },
    // { path: "/vehicle-brand", name: "Vehicle Brands", element: <VehicleBrand />, permission: "vehicle_brands.view" },
    // { path: "/vehicle-brand/add", name: "Add", element: <AddVehicleBrand />, permission: "vehicle_brands.create" },
    // { path: "/vehicle-brand/view/:id", name: "View", element: <ViewVehicleBrand />, permission: "vehicle_brands.view" },
    // { path: "/vehicle-brand/edit/:id", name: "Edit", element: <EditVehicleBrand />, permission: "vehicle_brands.update" },
    // { path: "/vehicle-model", name: "Vehicle Models", element: <VehicleModel />, permission: "vehicle_models.view" },
    // { path: "/vehicle-model/add", name: "Add", element: <AddVehicleModel />, permission: "vehicle_models.create" },
    // { path: "/vehicle-model/view/:id", name: "View", element: <ViewVehicleModel />, permission: "vehicle_models.view" },
    // { path: "/vehicle-model/edit/:id", name: "Edit", element: <EditVehicleModel />, permission: "vehicle_models.update" },
    { path: "/static-page", name: "Static Pages", element: <StaticPage />, permission: "static_pages.view" },
    // { path: "/static-page/add", name: "Add", element: <AddStaticPage /> },
    { path: "/static-page/view/:id", name: "View", element: <ViewStaticPage />, permission: "static_pages.view" },
    { path: "/static-page/edit/:id", name: "Edit", element: <EditStaticPage />, permission: "static_pages.update" },
    { path: "/call-logs", name: "Call Logs", element: <CallLogs />, permission: "call_logs.view" },
    { path: "/expired-memberships", name: "Expired Memberships", element: <ExpiredMembershipUsers />, permission: "users.view" },
    { path: "/invoice", name: "Invoice", element: <Invoice />, permission: "invoice.view" },
    { path: "/invoice/view/:id", name: "View", element: <ViewInvoice />, permission: "invoice.view" },
    { path: "/payment", name: "Payment", element: <PaymentHistory />, permission: "payment_history.view" },
    { path: "/demo-video", name: "Demo Video", element: <DemoVideo />, permission: "demo_video.view" },
    { path: "/user-subscriptions", name: "User Subscriptions", element: <UserSubscriptions />, permission: "user_subscriptions.view" },
    {
        path: "/sub-admin",
        name: "Sub-admins",
        element: <SubAdmins />,
        permission: "sub_admin.view",
    },
    { path: "/sub-admin/add", name: "Add Sub-admin", element: <SubAdminForm mode="ADD" />, permission: "sub_admin.view" },
    {
        path: "/sub-admin/edit/:id",
        name: "Edit Sub-admin",
        element: <SubAdminForm mode="EDIT" />,
        permission: "sub_admin.view",
    },
    {
        path: "/sub-admin/reset-password/:id",
        name: "Reset Sub-admin Password",
        element: <ResetSubAdminPassword />,
        permission: "sub_admin.reset_password",
    },
    { path: "/403", name: "Forbidden", element: <Forbidden /> },
];
